import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    discovery_rule_id?: String,
    discoveryRule? : String,
    filterSummary? : any
}

export const downloadDiscoveryRule = ({
    discovery_rule_id,
    discoveryRule,
    filterSummary,
    eventEmitter,
}: Props) => {
    eventEmitter.emit(Event.downloadDiscoveryRule, {discovery_rule_id, discoveryRule, filterSummary});
  
};

